import { classNamesFunction, FocusZone } from '@fluentui/react';
import { ThrowOnUndefinedColorContext } from '@m365-admin/customizations';
import * as React from 'react';
import { SubwayNavNodeState, SubwayNode } from '../subway-node/index';
import { getCurrentStep } from '../utilities/index';
const getClassNames = classNamesFunction();
const getItemClassNames = classNamesFunction();
export class SubwayNavBase extends React.Component {
    _classNames;
    _currentID; // ID of the current step
    static contextType = ThrowOnUndefinedColorContext;
    render() {
        const { styles, onRenderSteps = this._onRenderSteps, disabled = false, steps, wizardComplete, theme, focusZoneProps, } = this.props;
        this._classNames = getClassNames(styles, {
            steps,
            disabled,
            wizardComplete,
            theme: theme,
            colorThrowContext: this.context,
        });
        this._currentID = getCurrentStep(steps).id;
        return (React.createElement(FocusZone
        // Remove this line of explicitly setting role="list" after https://github.com/OfficeDev/office-ui-fabric-react/issues/9898 is fixed
        , { 
            // Remove this line of explicitly setting role="list" after https://github.com/OfficeDev/office-ui-fabric-react/issues/9898 is fixed
            role: "menubar", as: "ul", isCircularNavigation: true, ...focusZoneProps, className: this._classNames.root }, onRenderSteps(this.props)));
    }
    _onRenderSteps = (props) => {
        let _currentIndex = 0;
        const primaryStepLength = props.steps.length;
        const { disabled: wholeDisabled = false, wizardComplete } = props;
        return props.steps.map((step, primaryStepIndex) => {
            const { subSteps, state, id, onRenderSubSteps = this._onRenderSubSteps, disabled: stepDisabled, } = step;
            const indexToUse = _currentIndex;
            _currentIndex =
                _currentIndex +
                    1 +
                    (subSteps && state === SubwayNavNodeState.CurrentWithSubSteps
                        ? subSteps.length
                        : 0);
            const classNames = getItemClassNames(this._classNames.subComponentStyles.item, {
                index: indexToUse,
                id,
            });
            const isStepFunctionallyDisabled = wholeDisabled ?? stepDisabled ?? wizardComplete;
            const isStepVisuallyDisabled = this._isWholeVisuallyDisabled();
            return (React.createElement(React.Fragment, { key: id },
                React.createElement("li", { className: classNames.root, role: "presentation" },
                    React.createElement(SubwayNode, { role: "menuitem", "aria-posinset": primaryStepIndex + 1, "aria-setsize": primaryStepLength, iconAriaLabel: this.props.stateAriaLabels?.[step.state], isVisuallyDisabled: isStepVisuallyDisabled, ...(this._currentID === step.id && { 'aria-current': 'step' }), ...(step.subSteps && {
                            'aria-expanded': step.state === SubwayNavNodeState.CurrentWithSubSteps,
                        }), ...step, disabled: isStepFunctionallyDisabled, index: indexToUse })),
                onRenderSubSteps(step, indexToUse)));
        });
    };
    _onRenderSubSteps = (props, parentIndex) => {
        const { disabled: wholeDisabled = false } = this.props;
        const { disabled: subStepDisabled = false } = props;
        const isSubStepFunctionallyDisabled = wholeDisabled || subStepDisabled;
        const isSubStepVisuallyDisabled = this._isWholeVisuallyDisabled();
        return props.subSteps && props.state === SubwayNavNodeState.CurrentWithSubSteps ? (React.createElement(React.Fragment, null, props.subSteps.map((subStep, subIndex) => {
            const index = parentIndex + subIndex + 1;
            const subStepLength = props.subSteps?.length;
            const classNames = getItemClassNames(this._classNames.subComponentStyles.item, {
                index,
                id: subStep.id,
            });
            return (React.createElement("li", { key: subStep.id, role: "presentation", "data-substep": "true", className: classNames.root },
                React.createElement(SubwayNode, { isVisuallyDisabled: isSubStepVisuallyDisabled, disabled: isSubStepFunctionallyDisabled, iconAriaLabel: this.props.stateAriaLabels?.[subStep.state], ...(this._currentID === subStep.id && { 'aria-current': 'step' }), ...subStep, role: "menuitem", "aria-posinset": subIndex + 1, "aria-setsize": subStepLength, parentId: props.id, isSubStep: true, index: index })));
        }))) : null;
    };
    _isWholeVisuallyDisabled = () => {
        const { disabled: wholeDisabled = false, wizardComplete } = this.props;
        let stepVisuallyDisabled = wholeDisabled;
        if (wizardComplete) {
            stepVisuallyDisabled = false;
        }
        return stepVisuallyDisabled;
    };
}
//# sourceMappingURL=subway-nav.base.js.map